import React, { Component } from "react";

import { Doughnut } from "react-chartjs-2";
import { toPrice } from "../../helpers/functions.js"; 



export default class DoughnutChart extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: this.props.data
        };
    }

    render() {
        let priceMode = this.props.priceMode;
        return <Doughnut data={this.props.data} options={{
            plugins: {
                legend: {
                    display: false
                },
                tooltip: {
                    callbacks: {
                        label: function (tooltipItems, data) {
                            if (priceMode) {
                                return tooltipItems.label + ": " + toPrice(tooltipItems.raw);
                            } else {
                                return tooltipItems.label + ": " + tooltipItems.raw
                            }
                        }

                    },
                }
            },
            maintainAspectRatio: false
        }} />;
    }

}

DoughnutChart.defaultProps = {
    data: {
        label: [],
        datasets: [{
            label: '',
            data: [],
            backgroundColor: [],
            borderColor: [],
            borderWidth: 1
        }],

    }
}
